import React from "react";
import { Col } from "react-bootstrap";
import { QuestionCircle } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";
import Logo from "../img/completeDomain.webp";

interface IVerifyingInfoProps {
  children: React.ReactNode;
}

export default function VerifyingInfo({ children }: IVerifyingInfoProps) {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();

  return (
    <>
      <div className="border border-light rounded-2 px-3 pt-4 pb-5 mb-4 text-center">
        <Col lg={8} className="mx-auto">
          <Col xs={7} md={12} className="mx-auto">
            <img
              src={Logo}
              loading="lazy"
              alt="New Domain"
              className="img-fluid mb-4 my-md-4 pb-md-2"
            />
          </Col>
          <h4>{t("projects.Setup Complete")}!</h4>
          <h4 className="mb-3">
            {t("projects.We are Verifying your Connection Now.")}
          </h4>
          <div className="text-gray fs-7">
            {t("projects.All changes can take up to 72 hours.")}
          </div>
          <div className="text-gray fs-7">
            {t("projects.Check domain status in Own Domain page settings.")}
          </div>
          {children}
        </Col>
      </div>
      <div className="d-flex text-gray align-items-center mb-5 fs-7">
        <QuestionCircle className="me-2 fs-6" />
        {t("projects.Need help?")}
        <Link className="text-primary ms-1" to={`${lng}/support`}>
          {t("projects.Contact Us")}
        </Link>
      </div>
    </>
  );
}
